import React, { ReactNode } from 'react'
import './typography.sass'

const Paragraph: React.FC<{ children?: ReactNode | string }> = ({ children }) => {
    return <span className="typography-paragraph-text normal-text">{children}</span>
}

export default Paragraph
